export const RouterConst = {
  Dashboard: 'dashboard',
  Assets: 'assets',
  Enrolment: 'enrolment',
  Governance: 'governance',
  OrganizationManagement: 'governance/organizations',
  ApplicationManagement: 'governance/applications',
  RoleManagement: 'governance/roles',
  SearchResult: 'search-result',
  Enrol: 'enrol',
  Welcome: 'welcome',
  VerifiablePresentation: 'vp',

  AssetEnrolment: '/assets/enrolment/',
  MyEnrolments: '/enrolment?selectedTab=1',
  EnrolmentDetails: 'enrolment/:subject',

  ReturnUrl: 'returnUrl',
};
